export default "__VITE_ASSET__cT71V0fn__"